import React from 'react';
import { ReactEditor } from 'slate-react';

import { hotkeys } from 'commons/hotkeys';
import { toggleMark } from 'craft/rte/utils/marks';

export const keyMap = {
  copy: 'mod+c',
  bold: 'mod+b',
  code: 'mod+`',
  italic: 'mod+i',
  underline: 'mod+u',
  undo: 'mod+z',
  redo: 'mod+shift+z',
};
interface KeyDownHookArgs {
  editor: ReactEditor;
  callbacks: {
    onUndo: () => void;
    onRedo: () => void;
    onCopy: () => void;
  };
}

interface KeyDownHook {
  onKeyDown: (args: React.KeyboardEvent<Element>) => void;
}

type KeyDownHookConfig = (args: KeyDownHookArgs) => KeyDownHook;
export const useKeydown: KeyDownHookConfig = ({
  editor,
  callbacks: { onUndo, onRedo, onCopy },
}) => {
  const markHandler = (e: any, shortcut: any, format: string) => {
    e.preventDefault();
    toggleMark(editor, format);
  };

  const handlers = () => {
    return {
      // marks
      copy: onCopy,
      bold: markHandler,
      code: markHandler,
      italic: markHandler,
      underline: markHandler,
      undo: onUndo,
      redo: onRedo,
    };
  };

  const onKeyDown = hotkeys({ keyMap, handlers: handlers() });
  return { onKeyDown };
};
